import { utils } from '../utils.js'

export interface ErrorParameters {
	Message: string
	StackTrace?: string
}

export const errorParametersFactory = {
	create(error: unknown, event?: unknown): ErrorParameters {
		const parameters: ErrorParameters = { Message: '' }
		if (error instanceof Error) {
			parameters.Message = error.message
				? `${error.name}: ${error.message}`
				: error.name
			parameters.StackTrace = utils.toString(error)
		} else {
			parameters.Message = utils.toString(error)
		}
		if (event && error && typeof error === 'object') {
			(error as { event?: unknown }).event = event
		}
		return parameters
	}
}
